(ns frontend.view.modals.folder-selection-modal.sub
  (:require
   [common.localization :as loc]
   [common.util :as cu]
   [re-frame.core :as rf]))

(rf/reg-sub
 ::selected-folder
 (fn [db]
   (get db ::selected-folder)))

(rf/reg-sub
 ::original-path
 (fn [db]
   (get db ::original-path)))

(rf/reg-sub
 ::folder-choices
 (fn [db]
   (get db ::folder-choices)))

(rf/reg-sub
 ::folder-options
 :<-
 [::folder-choices]
 (fn [folder-choices [_]]
   (->> folder-choices
        (remove cu/blank-value?)
        (map (fn [n]
               {:label n
                :value (cu/str-trim-lcase n)}))
        (concat [{:value ""
                  :label (loc/tr :root-folder-when-moving)}]))))

(rf/reg-sub
 ::changes?
 :<-
 [::selected-folder]
 :<-
 [::original-path]
 (fn [[selected-folder original-tree] _]
   (not= (str "/" selected-folder) original-tree)))

(rf/reg-sub
 ::processing?
 (fn [db]
   (get db ::processing?)))

(rf/reg-sub
 ::target-entity
 (fn [db]
   (get db ::target-entity)))
